import fetchClient from '../components/common/FetchClient';

const requestOrderPlannerContactsType = 'REQUEST_ORDERPLANNER_CONTACTS';
const receiveOrderPlannerContactsType = 'RECEIVE_ORDERPLANNER_CONTACTS';
const initialState = {
    isLoading: false,
    selectedContactId: '',
    contacts: [],
    requirePO: false,
    uniquePO: false,
    requireCreditCard: false
};

export const actionCreators = {
    queryOrderPlannerContacts: queryData => async (dispatch, getState) => {

        var customer = localStorage.getItem('customer');
        var addressId = localStorage.getItem('address');

        var contacts = [];

        dispatch({ type: requestOrderPlannerContactsType, customer, addressId });

        const url = `/api/OrderPlanner/RetrieveContacts`;

        fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
                addressId: localStorage.getItem('address')
            }})
            .then(function (resp) {
                if (resp) {

                    console.log(resp);

                    if (!resp.data.ContactReqResp) {
                        var contact = {};
                        contact.Id = 'NA';
                        contact.Name = 'Error contacting app service. Check internet connection and app login.';

                        contacts.push(contact);

                        console.log(contacts);
                    }
                    else if (resp.data.ContactReqResp.ResponseCode.Msg !== "Request successful.") {

                        var newContact = {};
                        newContact.Id = 'NA';
                        newContact.Name = resp.data.ContactReqResp.ResponseCode.Msg;

                        contacts.push(newContact);
                    }
                    else {
                        var detailsTree = resp.data.ContactReqResp;

                        var poDetails = detailsTree.PODetails;
                        var requirePO = poDetails.RequirePO === 'Yes';
                        var uniquePO = poDetails.UniquePO === 'Yes';
                        var requireCC = detailsTree.PaymentDetails.RequireCreditCard === 'True';

                        localStorage.setItem('requireCC', requireCC);
                        localStorage.setItem('requirePO', requirePO);
                        localStorage.setItem('requireUniquePO', uniquePO);

                        if (Array.isArray(resp.data.ContactReqResp.Contact)) {
                            resp.data.ContactReqResp.Contact.map((contact) => {
                                contacts.push(contact);

                                return '';
                            });
                        }
                        else if (resp.data.ContactReqResp.Contact) {
                            contacts.push(resp.data.ContactReqResp.Contact);
                        }
                        else {
                            newContact = {};
                            newContact.Id = 'NA';
                            newContact.Name = 'No contacts found.';

                            contacts.push(newContact);
                        }
                    }

                    dispatch({ type: receiveOrderPlannerContactsType, contacts, customer, addressId, requireCC });
                }
            });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestOrderPlannerContactsType) {

        return {
            ...state,
            customer: action.customer,
            addressId: action.addressId,
            isLoading: true
        };
    }

    if (action.type === receiveOrderPlannerContactsType) {
        return {
            ...state,
            contacts: action.contacts,
            customer: action.customer,
            addressId: action.addressId,
            requireCC: action.requireCC,
            isLoading: false
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/OrderPlannerContact.js